export default "__VITE_ASSET__BFtsJrnJ__"